import { ValidationResponse, ValidationStatuses } from './types';
import apiClient from 'apiClient';
import { AxiosResponse } from 'axios';
import cachedValidateRequest from './cachedValidateRequest';

interface Params {
  tioRemainingLeaseYears: number;
}
interface ResponseData extends Omit<ValidationResponse, 'params'> {}
interface ResponseDataWithParams extends Required<ValidationResponse<Params>> {}

export class LeaseLengthValidationError extends Error {
  params: Params;

  constructor(params: Params) {
    super(`Sorry, we are unable to lend on property with a lease below ${params.tioRemainingLeaseYears} years`);
    this.params = params;
  }
}

const isResponseWithParams = (
  response: AxiosResponse<ValidationResponse<Params>>,
): response is AxiosResponse<ResponseDataWithParams> => response.data.status !== ValidationStatuses.OK;

const validate = async (
  productType: string,
  propertyTenure: string,
  remainingLeaseYears: number,
): Promise<ResponseData> => {
  const response = await apiClient.post('/api/v1/business-rules/validate-lease-length', {
    productType,
    propertyTenure,
    remainingLeaseYears,
  });

  if (isResponseWithParams(response)) {
    throw new LeaseLengthValidationError(response.data.params);
  }

  return { status: response.data.status, details: response.data.details };
};

const cachedValidate = async (productType: string, propertyTenure: string, remainingLeaseYears: number) => {
  return cachedValidateRequest(async () => {
    return await validate(productType, propertyTenure, remainingLeaseYears);
  }, `validate-lease-length-${productType}-${propertyTenure}-${remainingLeaseYears}`);
};

const exportObject = { validate, cachedValidate };

export default exportObject;
